module.exports = __webpack_public_path__ + "static/img/you_video_pic1.6.c7a4441.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/intro/you_video_pic1.6.jpg
// module id = P9i+
// module chunks = 0